import React from "react";
import clsx from "clsx";
import CircularProgress from "@material-ui/core/CircularProgress";
import Container from "@material-ui/core/Container";
import useStyles from "./styles";

export interface Props {
  className?: string;
  size?: number;
  disableGutters?: boolean;
  infinite?: boolean;
  overlay?: boolean;
}

const Loader = (props: Props) => {
  const { className, size, disableGutters, infinite, overlay } = props;
  const classes = useStyles();

  return (
    <Container
      className={clsx(className, classes.loaderContainer, {
        [classes.infinite]: infinite,
        [classes.overlay]: overlay
      })}
      disableGutters={disableGutters}
      maxWidth={false}
    >
      <CircularProgress size={size} />
    </Container>
  );
};

export default Loader;
